module.exports = __webpack_public_path__ + "static/media/attachment.a6e21c85.png";